module.exports = __webpack_public_path__ + "static/media/logo-tasa-documentos.046d20a0.png";